import './App.css';
import { BrowserRouter, Route, Routes, Navigate } from 'react-router-dom';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import MainLayout from './components/MainLayout';
import CrearForecast from './screens/Forecast/CrearForecast';
import MostrarNominas from './screens/Nominas/MostrarNominas';
import Dashboard from './screens/Home/Dashboard';
import Jobtrack from './screens/Home/Jobtrack';
import Presupuestos from './screens/Forecast/Presupuestos';
import Login from './screens/Login/Login';
import Acceso from './screens/Admin/Acceso';
import NecesidadCompra from './screens/Compras/NecesidadCompra';
import HistorialPlanta from './screens/Home/HistorialPlanta';
import RequestAccess from './screens/Admin/RequestAccess';
import Proceso from './screens/Home/Proceso';
import Roles from './screens/Home/Roles';
import ReportesPlanta from './screens/Home/ReportesPlanta';
import Quejas from './screens/Publicas/Quejas';
import {AmplifyConfig} from './scripts/configs/AmplifyConfig';
import { Amplify } from 'aws-amplify';
import { cognitoUserPoolsTokenProvider } from 'aws-amplify/auth/cognito';
import { sessionStorage } from 'aws-amplify/utils';
import { AuthProvider } from './scripts/functions/AuthProvider';
import ProtectedRoute from './components/ProtectedRoute';
import RedirectionPage from './components/RedirectionPage';
import NotificationStack from './components/NotificationStack';
import { ThemeProvider } from './scripts/functions/ThemeProvider';
Amplify.configure(AmplifyConfig);

// Must run AFTER Amplify.configure, otherwise configure resets it to the default localStorage.
cognitoUserPoolsTokenProvider.setKeyValueStorage(sessionStorage);

const queryClient = new QueryClient({
  defaultOptions : {
    queries: {
      staleTime: 1000 * 60 * 5, //Consider data as fresh for 5 minutes
      refetchOnWindowFocus: false,  //Avoid refetching information if the user switches tabs
    }
  }
})

function App() {
  return (
    //All the app needs to have access to the Auth context
    <AuthProvider>
      <QueryClientProvider client={queryClient}>
        <ThemeProvider>
          <NotificationStack/>
          <BrowserRouter>
            <Routes>
              <Route path="/" element={<Navigate to="/login" replace />} />
              <Route path="login" element={<Login/>}/>
              {/* This route MUST be public */}
              <Route path="administracion/request-access" element={<RequestAccess/>}/>
              <Route path="sugerencias" element={<Quejas/>}/>
              <Route path="/" element={<MainLayout/>}>
                <Route path="deny-access" element={<RedirectionPage error={403} page="/produccion/dashboard"/>}/>

                <Route element={<ProtectedRoute requiredDepartments={['produccion']}/>}>
                  <Route path="produccion">
                    <Route path="dashboard" element={<Dashboard/>}/> 
                    <Route path="proceso" element={<Proceso/>}/>
                    <Route path="jobtrack" element={<Jobtrack/>}/>  
                    <Route path="historialplanta" element={<HistorialPlanta/>}/>  
                    <Route path="roles" element={<Roles/>}/>
                    <Route path="reportesplanta" element={<ReportesPlanta/>}/>
                  </Route> 
                </Route>
                <Route element={<ProtectedRoute requiredDepartments={['ventas']}/>}>
                  <Route path="ventas" >
                    <Route path="forecast" element={<CrearForecast/>}/> 
                    <Route path="presupuesto" element={<Presupuestos/>}/>   
                  </Route>
                </Route>
                <Route element={<ProtectedRoute requiredDepartments={['compras']}/>}>
                  <Route path="compras" >
                    <Route path="necesidadcompra" element={<NecesidadCompra/>}/> 
                  </Route>
                </Route>
                <Route element={<ProtectedRoute requiredDepartments={['recursos humanos']}/>}>
                  <Route path="recursoshumanos" >
                    <Route path="rh" element={<div>recursos</div>}/> 
                    <Route path="nominas" element={<MostrarNominas/>}/>   
                  </Route>
                </Route>
                <Route element={<ProtectedRoute requiredDepartments={['admin']}/>}>
                  <Route path="administracion" >
                    <Route path="acceso" element={<Acceso/>}/> 
                  </Route>
                </Route>
                {/* Fallback route */}
                <Route path="*" element={<RedirectionPage error={404} page="/produccion/dashboard"/>}/>
              </Route>
            </Routes>
          </BrowserRouter>
        </ThemeProvider>
      </QueryClientProvider>
    </AuthProvider>
  );
}

export default App;
